import { computed, ref } from 'vue'
import { defineStore } from 'pinia'
import userApi from '@/api/userApi'
import { useBannerStore } from '@/stores/bannerStore'
import { useSettingsStore } from '@/stores/settingsStore'

export const useUserStore = defineStore('userStore', () => {
  const connectedUser = ref<UserMe | null>(null)
  const currentUser = ref<UserMe | null>(null)

  const isLoggedIn = computed(() => {
    return currentUser.value !== null
  })

  const setConnectedUser = async (user: UserMe) => {
    const bannerStore = useBannerStore()
    useSettingsStore().load()
    bannerStore.reset()
    let resolvedUser = user;

    if(sessionStorage.getItem('MyNemo.impersonatedUserId')) {
      const impersonatedUserId = parseInt(sessionStorage.getItem('MyNemo.impersonatedUserId')!, 10)
      if (!isNaN(impersonatedUserId)) {
        await userApi.getImpersonatedAs().then(result => {
          resolvedUser = result.data
        }).catch(() => {
          // Ignore if error occured while fetching impersonated user, fallback to original user
        })
      }
    }

    connectedUser.value = user
    currentUser.value = resolvedUser
    await bannerStore.load(resolvedUser.id)
  }

  const setCurrentUser = async (user: UserMe) => {
    if(connectedUser.value == null) throw new Error('Connected user must be set before setting current user')
    currentUser.value = user
    const bannerStore = useBannerStore()
    bannerStore.reset()
    await bannerStore.load(user.id)
  }

  const logout = async () => {
    if(connectedUser.value) {
      try { await userApi.logout() } catch { /* ignore */ }
    }
    connectedUser.value = null
    currentUser.value = null
    useBannerStore().reset()
  }

  // const isAdmin = computed(() => {
  //   return connectedUser.value?.isAdmin === true
  // })

  const isImpersonated = computed(() => {
    return connectedUser.value?.id !== currentUser.value?.id;
  })

  const stopImpersonation = () => {
    sessionStorage.removeItem('MyNemo.impersonatedUserId');
    window.location.reload();
  }

  return { isLoggedIn, connectedUser, currentUser, setConnectedUser, setCurrentUser, logout, isImpersonated, stopImpersonation }
})
